<template>
	<div>
		<!-- begin page-header -->
		<h1 class="page-header mb-3">Bienvenido Vendedor :<b>
				<!-- {{ $store.state.usuario.tipo_vendedor==1 ?  '(FFVV)' : $store.state.usuario.tipo_vendedor==2 ? '(PDV)' : 'SIN DEFINIR'}} -->
				{{filtrar($store.state.usuario.tipo_vendedor)}}
				</b>
			&nbsp; <b>{{  $store.state.usuario.nombres | mayuscula}}
				{{$store.state.usuario.appa | mayuscula}} {{$store.state.usuario.apma | mayuscula}}</b>
			&nbsp;&nbsp;
			<a v-show="$store.state.usuario.tipo_vendedor==2 && !cargando" v-b-modal.modalDialog href="javascript:;"
				class="btn btn-lg btn-warning">
				<span class="d-flex align-items-center text-left">
					<span class="fa-stack fa-2x text-white">
						<i class="far fa-square fa-stack-2x"></i>
						<i class="fas fa-sync fa-spin fa-stack-1x"></i>
						<!-- <i class="fa fa-info fa-stack-1x"></i> -->
					</span>
					<span>
						<span class="d-block mb-n1"><b>Calificas para Aguinaldos</b></span>
						<span class="f-s-12 f-w-600 text-white-transparent-7">Verifícalo</span>
					</span>
				</span>
			</a>
		</h1>
		<!-- end page-header -->

		<!-- begin row -->

		<div class="row" v-if="cargando">

			<div class="col-xl-12 text-center font-weight-bold">
				<br>
				<br>
				<br>
				<br>
				<h2> Cargando... <i class="fa fa-spin fa-spinner"></i> </h2>
			</div>
		</div>
		<div class="row" v-if="!cargando">
			<!-- begin col-6 -->
			<div class="col-xl-6">
				<!-- begin card -->
				<div class="card border-0 bg-dark text-white mb-3 overflow-hidden">
					<!-- begin card-body -->
					<div class="card-body">
						<!-- begin row -->
						<div class="row">
							<!-- begin col-7 -->
							<div class="col-xl-7 col-lg-8">
								<!-- begin title -->
								<div class="mb-3 text-grey">
									<b>TOTAL SALDO DEL MES ACTUAL</b>
									<span class="ml-2">
										<i class="fa fa-info-circle" title="Total saldo"
											v-b-popover.hover="'Es la suma del total de chip y equipo vendidos.'"></i>
									</span>
								</div>
								<!-- end title -->
								<!-- begin total-sales -->
								<div class="d-flex mb-1">
									<h2 class="mb-0" style="display: inline">
										S/.
										<number style="display: inline" ref="number2" class="bold transition"
											:class="{scaleBig: false}" :from="0" :format="theFormat" animationPaused
											:to="saldo.monto_mes-monto_adelanto_mes_actual" :duration="5"
											easing="Power4.easeOut" @complete="completed" />
									</h2>
									&nbsp;
									&nbsp;
									<div class="ml-auto mt-n1 mb-n1">
										<apexchart height="36px" :options="totalSalesChart.options"
											:series="totalSalesChart.series"></apexchart>
									</div>
								</div>
								<!-- end total-sales -->
								<!-- begin percentage -->
								<div class="mb-3 text-grey">
									<a v-b-modal.modalDialog href="#"> Ver Saldos Anteriores </a>
								</div>
								<!-- end percentage -->
								<hr class="bg-white-transparent-2" />
								<!-- begin row -->
								<div class="row text-truncate">
									<!-- begin col-6 -->
									<div class="col-6">
										<div class="f-s-12 text-grey">Total en chips vendidos</div>
										<div class="f-s-18 m-b-5 f-w-600 p-b-1">S/.{{saldo.monto_chip}}</div>
										<div class="progress progress-xs rounded-lg bg-dark-darker m-b-5">
											<div class="progress-bar progress-bar-striped rounded-right bg-teal"
												style="width: 100%"></div>
										</div>
									</div>
									<!-- end col-6 -->
									<!-- begin col-6 -->
									<div class="col-6">
										<div class="f-s-12 text-grey">Total en equipos vendidos</div>
										<div class="f-s-18 m-b-5 f-w-600 p-b-1">S/.{{saldo.monto_equipo}}</div>
										<div class="progress progress-xs rounded-lg bg-dark-darker m-b-5">
											<div class="progress-bar progress-bar-striped rounded-right"
												style="width: 100%"></div>
										</div>
									</div>
									<br>
									<div class="col-6">
										<div class="f-s-12 text-grey">Total en adelantos</div>
										<div class="f-s-18 m-b-5 f-w-600 p-b-1">S/.{{monto_adelanto_mes_actual}}</div>
										<div class="progress progress-xs rounded-lg bg-dark-darker m-b-5">
											<div class="progress-bar progress-bar-striped rounded-right bg-danger"
												style="width: 100%"></div>
										</div>
									</div>
									<!-- end col-6 -->
								</div>
								<!-- end row -->
							</div>
							<!-- end col-7 -->
							<!-- begin col-5 -->
							<div class="col-xl-5 col-lg-4 align-items-center d-flex justify-content-center">
								<img src="/app/assets/img/svg/img-1.svg" height="150px" class="d-none d-lg-block" />
							</div>
							<!-- end col-5 -->
						</div>
						<!-- end row -->
					</div>
					<!-- end card-body -->
				</div>
				<!-- end card -->
			</div>
			<!-- end col-6 -->
			<!-- begin col-6 -->
			<div class="col-xl-6">
				<!-- begin row -->
				<div class="row">
					<div class="col-xl-6">
						<!-- begin card -->
						<div class="card border-0 bg-dark-darker text-white mb-3">
							<!-- begin card-body -->
							<div class="card-body"
								style="background: no-repeat bottom right; background-image: url(/app/assets/img/svg/img-4.svg); background-size: auto 60%;">
								<!-- begin title -->
								<div class="mb-3 text-grey">
									<b>ÚLTIMOS 5 CHIPS VENDIDOS DEL MES</b>
									<a v-b-modal.modalDialog2 href="#" class="text-grey ml-2"><i
											class="fa fa-info-circle" title="Informe completo"
											v-b-popover.hover="'Haga click para ver todas las ventas de los chips durante este mes.'"></i>
										Ver Todo</a>

								</div>
								<!-- end title -->
								<!-- begin sales -->
								<!-- end sales -->
							</div>
							<!-- end card-body -->
							<!-- begin widget-list -->
							<div v-for="c in chips_5_vendidos" :key="c.Id"
								class="widget-list widget-list-rounded inverse-mode">
								<!-- begin widget-list-item -->
								<a href="#" class="widget-list-item rounded-0 p-t-3">
									<div class="widget-list-media icon">
										<!-- <i class="fab fa-apple bg-indigo text-white"></i> -->
										<i class="fas fa-microchip fa-lg text-white"></i>
									</div>
									<div class="widget-list-content">
										<div class="widget-list-title">{{c.chip}}</div>
										<div class="text-grey">{{c.comision_nombre}} <br>
											<small>{{c.fecha_venta}}</small></div>
									</div>
									<div class="widget-list-action text-nowrap text-grey">
										S/.{{parseFloat(c.monto).toFixed(2)}}
										<div class="text-grey f-s-10">comisión</div>
									</div>

								</a>
								<!-- end widget-list-item -->

							</div>
							<!-- end widget-list -->
						</div>
						<!-- end card -->
					</div>
					<!-- end col-4 -->
					<!-- end col-4 -->
					<!-- begin col-4 -->
					<div class="col-xl-6">
						<!-- begin card -->
						<div class="card border-0 bg-dark text-white mb-3">
							<!-- begin card-body -->
							<div class="card-body">
								<!-- begin title -->
								<div class="mb-3 text-grey">
									<b>ÚLTIMOS 5 EQUIPOS VENDIDOS DEL MES</b>
									<a v-b-modal.modalDialog3 href="#" class="ml-2"><i class="fa fa-info-circle"
											title="Informe completo de equipos"
											v-b-popover.hover="'Haga click para ver todos los equipos vendidos.'"></i>
										Ver Todo</a>
								</div>
								<!-- end title -->
								<!-- begin product -->
								<div v-for="(e, index) in equipos_5_vendidos" :key="e.Id"
									class="d-flex align-items-center m-b-15">
									<div class="widget-img rounded-lg width-30 m-r-10 bg-white p-3">
										<div class="h-100 w-100"
											:style="'background: url(/app/assets/img/product/product-'+(index+1)+'.png) center no-repeat; background-size: auto 100%;'">
										</div>
									</div>
									<div class="text-truncate">
										<div>{{e.modelo}}</div>
										<div class="text-grey">{{e.comision_nombre}} <br>
											IMEI: <b>{{e.imei}}</b></div>
									</div>
									<div class="ml-auto text-center">
										<div class="f-s-13">s/.{{parseFloat(e.monto).toFixed(2)}}</div>
										<div class="text-grey f-s-10">{{e.fecha_venta}}</div>
									</div>
								</div>
								<!-- end product -->

							</div>
							<!-- end card-body -->
						</div>
						<!-- end card -->
					</div>

				</div>
				<!-- end row -->
			</div>
			<!-- end col-6 -->
		</div>
		<!-- end row -->

		<br>
		<div class="row" v-if="!cargando">

			<div class="col-lg-6 offset-lg-3">
				<div class="panel panel-inverse" data-sortable-id="table-basic-1">

					<div class="panel-heading ui-sortable-handle">
						<h4 class="panel-title">En la sección, encontrarás información actualizada que te ayudará a
							tener más recursos para las ventas.</h4>

					</div>


					<div class="panel-body">

						<div class="table-responsive">
							<table class="table mb-0 table-sm">
								<thead>
									<tr>
										<th>#</th>
										<th>Título</th>
										<th>Link</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, index) in links" :key="item.Id">
										<td>{{index+1}}</td>
										<td>{{item.titulo}}</td>
										<td> <a :href="item.link" target="_blank" class="btn btn-primary btn-sm"> <i
													class="fa fa-link"></i> abrir link</a> </td>
									</tr>

								</tbody>
							</table>
						</div>

					</div>



				</div>
			</div>

		</div>
		<br>
		<div class="row bg-white rounded p-4" v-if="!cargando">
			<div class="col-xl-12 text-center">
				<p class="lead">
					<em><b> "{{saldo.frase}}"</b></em>
				</p>
			</div>
		</div>


		<b-modal ref="modalDialog" size="xl" id="modalDialog" cancel-variant="default" title="Saldos anteriores">
			<div class="form-group">
				<label for="">Seleccione el Año</label>
				<div class="row">
					<div class="col-md-3 col-sm-3 col-xs-3">
						<select class="form-control font-weight-bold" @change="montos_anteriores=[]"
							v-model="anio_saldo_anterior">
							<option value="2021">2021</option>
							<option value="2022">2022</option>
							<option value="2023">2023</option>
							<option value="2024">2024</option>
							<option value="2025">2025</option>
							<option value="2026">2026</option>
							<option value="2027">2027</option>
							<option value="2028">2028</option>
							<option value="2029">2029</option>
							<option value="2030">2030</option>
						</select>
					</div>
					<div class="col-md-9 col-sm-9 col-xs-9">
						<button type="button" @click="cargarSaldoAnterior() " class="btn btn-dark"> <i
								class="fa fa-search"></i> Buscar</button>
					</div>
				</div>
			</div>
			<div class="table-responsive">
				<table class="table table-hover">
					<thead>
						<tr>
							<th>AÑO</th>
							<th>MES</th>
							<th>MONTO CHIP</th>
							<th>MONTO EQUIPO</th>
							<th>MONTO ADELANTOS</th>
							<th>MONTO TOTAL</th>
							<!-- <th v-show="$store.state.usuario.tipo_vendedor==2 && anio_saldo_anterior>2021">A.
								ESCOLARIDAD (15%)</th>
							<th v-show="$store.state.usuario.tipo_vendedor==2 && anio_saldo_anterior>2021">A. FIESTAS
								PATRIAS (10%)</th>
							<th v-show="$store.state.usuario.tipo_vendedor==2 && anio_saldo_anterior>2021">A. NAVIDAD
								(10%)</th> -->
							<th>DETALLE</th>
						</tr>
					</thead>
					<tr v-for="(m , index) in montos_anteriores" :key="m.Id">
						<td>{{m.anio}}</td>
						<td>{{m.mes}}</td>
						<td>S/.{{m.monto_chip}}</td>

						<td>S/.{{m.monto_equipo}}</td>
						<td>- S/.{{m.monto_adelanto}}</td>
						<th>S/.{{m.total}}</th>
						<!-- <th v-show="$store.state.usuario.tipo_vendedor==2 && anio_saldo_anterior>2021">
							<span v-show="validarEscolaridad(m.mes)">S/.{{(m.monto_chip*0.15).toFixed(2)}}</span>
						</th>
						<th v-show="$store.state.usuario.tipo_vendedor==2 && anio_saldo_anterior>2021">
							<span v-show="validarFiestasPatrias(m.mes)">S/.{{(m.monto_chip*0.10).toFixed(2)}}</span>
						</th>
						<th v-show="$store.state.usuario.tipo_vendedor==2 && anio_saldo_anterior>2021">
							<span v-show="validarFiestasNavidad(m.mes)">S/.{{(m.monto_chip*0.10).toFixed(2)}}</span>
						</th> -->
						<th>
							<a :href="'#/detalle-pago/'+(index+1)+'/'+m.anio+'/'+$store.state.usuario.dni+'/'+$store.state.usuario.appa+' '+$store.state.usuario.apma+' '+$store.state.usuario.nombres"
								class="btn btn-sm btn-danger"> <small> Ver</small></a>
							<b-button variant="secondary" size="sm" class="float-right"
								@click="imprimirBoleta(m.monto_chip,m.monto_equipo,m.monto_adelanto,m.total,m.mes)">
								Boleta
							</b-button>

						</th>
					</tr>
				</table>
			</div>
			<hr>
			<div v-show="false">
				<h4 v-show="$store.state.usuario.tipo_vendedor==2 && anio_saldo_anterior>2021">BONOS</h4>
				<div class="table-responsive">
					<table v-show="$store.state.usuario.tipo_vendedor==2 && anio_saldo_anterior>2021"
						class="table table-hover">
						<thead>
							<tr>
								<th>AGUINALDO ESCOLAR (14 de Marzo)</th>
								<th>AGUINALDO FIESTAS PATRIAS (18 de Julio)</th>
								<th>AGUINALDO POR NAVIDAD (Diciembre)</th>
							</tr>
						</thead>
						<tr>
							<th>S/.{{escolaridad_total}}</th>
							<th>S/.{{fiestas_patrias_total}}</th>
							<th>S/.{{navidad_total}}</th>
						</tr>
					</table>
				</div>
			</div>

			<template #modal-footer>
				<b-button variant="secondary" size="sm" class="float-right" @click="$bvModal.hide('modalDialog')">Cerrar
				</b-button>
			</template>
		</b-modal>



		<b-modal ref="modalDialog2" id="modalDialog2" cancel-variant="default" title="CHIPS VENDIDOS DURANTE EL MES">
			<table class="table table-hover">
				<thead>
					<tr>
						<th>CHIP</th>
						<th>NOMBRE COMISIÓN</th>
						<th>COMISIÓN</th>
						<th>FECHA DE VENTA</th>
					</tr>
				</thead>
				<tr v-for="c in chips_vendidos" :key="c.Id">
					<td>{{c.chip}}</td>
					<td>{{c.comision_nombre}}</td>
					<td>S/.{{parseFloat(c.monto).toFixed(2)}}</td>
					<td>{{c.fecha_venta}}</td>
				</tr>
			</table>
			<template #modal-footer>
				<b-button variant="secondary" size="sm" class="float-right" @click="$bvModal.hide('modalDialog2')">
					Cerrar
				</b-button>



			</template>
		</b-modal>

		<b-modal ref="modalDialog3" id="modalDialog3" cancel-variant="default" title="EQUIPOS VENDIDOS DURANTE EL MES">
			<table class="table table-hover">
				<thead>
					<tr>
						<th>EQUIPO</th>
						<th>IMEI</th>
						<th>NOMBRE COMISIÓN</th>
						<th>COMISIÓN</th>
						<th>FECHA DE VENTA</th>
					</tr>
				</thead>
				<tr v-for="c in equipos_vendidos" :key="c.Id">
					<td>{{c.modelo}}</td>
					<td>{{c.imei}}</td>
					<td>{{c.comision_nombre}}</td>
					<td>S/.{{parseFloat(c.monto).toFixed(2)}}</td>
					<td>{{c.fecha_venta}}</td>
				</tr>
			</table>
			<template #modal-footer>
				<b-button variant="secondary" size="sm" class="float-right" @click="$bvModal.hide('modalDialog3')">
					Cerrar
				</b-button>
			</template>
		</b-modal>


	</div>
</template>

<script>
	import Vue from 'vue'
	import VueNumber from 'vue-number-animation'
	import axios from 'axios'

	Vue.use(VueNumber)
	export default {
		name: 'dashboard-v3',
		beforeMount() {
			this.cargarAdelantos();
			this.cargarSaldo();
			// this.cargarSaldoAnterior();
			this.cargarUltimosChipVendidos();
			this.cargarUltimosEquiposVendidos();
			this.cargarLinks();
		},
		created() {
			var fecha = new Date();
			this.anio_saldo_anterior = fecha.getFullYear();
		},
		data() {
			function handleGetDate(minusDate) {
				var d = new Date();
				d = d.setDate(d.getDate() - minusDate);
				return d;
			}

			var convertNumberWithCommas = function (x) {
				return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			};

			return {
				cargando: true,
				montos_anteriores: [],
				anio_saldo_anterior: "",
				escolaridad: "",
				fiestas_patrias: "",
				navidad: "",
				saldo: {
					dni: "",
					frase: "",
					monto_chip: "",
					monto_equipo: "",
					monto_mes: "",

					personal: "",
					tipo: ""
				},
				monto_adelanto_mes_actual: "",
				links: [],
				chips_vendidos: [],
				chips_5_vendidos: [],
				equipos_vendidos: [],
				equipos_5_vendidos: [],
				totalSalesChart: {
					options: {
						chart: {
							type: 'line',
							width: 200,
							height: 36,
							sparkline: {
								enabled: true
							},
							stacked: true
						},
						stroke: {
							curve: 'smooth',
							width: 3
						},
						fill: {
							type: 'gradient',
							gradient: {
								opacityFrom: 1,
								opacityTo: 1,
								colorStops: [{
										offset: 0,
										color: '#348fe2',
										opacity: 1
									},
									{
										offset: 100,
										color: '#8753de',
										opacity: 1
									}
								]
							},
						},
						tooltip: {
							theme: 'dark',
							fixed: {
								enabled: false
							},
							x: {
								show: false
							},
							y: {
								title: {
									formatter: function () {
										return 'Saldo';
									}
								},
								formatter: (value) => {
									return 'S/.' + convertNumberWithCommas(value)
								},
							},
							marker: {
								show: false
							}
						},
						responsive: [{
							breakpoint: 1500,
							options: {
								chart: {
									width: 130
								}
							}
						}, {
							breakpoint: 1300,
							options: {
								chart: {
									width: 100
								}
							}
						}, {
							breakpoint: 1200,
							options: {
								chart: {
									width: 200
								}
							}
						}, {
							breakpoint: 576,
							options: {
								chart: {
									width: 180
								}
							}
						}, {
							breakpoint: 400,
							options: {
								chart: {
									width: 120
								}
							}
						}]
					},
					series: [{
						data: []
					}]
				},


			}
		},
		methods: {
			cargarSaldo() {

				// console.log(this.totalSalesChart.series[0]['data']);

				axios.post(this.URL_BASE() + "saldo_vendedor/detalle_vendedor/" + this.$store.state.usuario.dni).then(
					respuesta => {
						if (respuesta.data.msg == 'exito') {
							this.saldo = {
								...respuesta.data.data[0]
							};
							this.cargando = false;
						}
						setTimeout(() => {
							this.playAnimation();
						}, 250);

					}).catch(function (error) {
					console.log("er store" + error);
				});
			},
			cargarAdelantos() {

				axios.post(this.URL_BASE() + "adelantos/ver_adelanto/" + this.$store.state.usuario.dni).then(
					respuesta => {
						if (respuesta.data.msg == 'exito') {
							this.monto_adelanto_mes_actual = respuesta.data.data[0]['monto_mes_adelanto'];
						}


					}).catch(function (error) {
					console.log("er store" + error);
				});
			},
			cargarSaldoAnterior() {
				axios.post(this.URL_BASE() + "saldo_vendedor/saldo_anterior/" + this.$store.state.usuario.dni + "/" + this
					.anio_saldo_anterior).then(
					respuesta => {
						if (respuesta.data.msg == 'exito') {
							respuesta.data.data.forEach(element => {
								this.totalSalesChart.series[0]['data'].push(element.total);
							});
							this.montos_anteriores = respuesta.data.data;
						}
						setTimeout(() => {
							this.playAnimation();
						}, 250);

					}).catch(function (error) {
					console.log("er store" + error);
				});
			},
			cargarUltimosChipVendidos() {
				axios.post(this.URL_BASE() + "detalle_ventas_chip/ultimos_chips_vendidos/" + this.$store.state.usuario.dni)
					.then(
						respuesta => {
							if (respuesta.data.msg == 'exito') {
								this.chips_vendidos = [...respuesta.data.data];
								let i = 1;
								respuesta.data.data.forEach(element => {
									if (i < 6) {
										this.chips_5_vendidos.push(element);
									}
									i++;
								});
							}


						}).catch(function (error) {
						console.log("er store" + error);
					});
			},
			cargarUltimosEquiposVendidos() {
				axios.post(this.URL_BASE() + "detalle_ventas_equipo/ultimos_equipos_vendidos/" + this.$store.state.usuario
					.dni).then(
					respuesta => {
						if (respuesta.data.msg == 'exito') {
							this.equipos_vendidos = [...respuesta.data.data];
							let i = 1;
							respuesta.data.data.forEach(element => {
								if (i < 6) {
									this.equipos_5_vendidos.push(element);
								}
								i++;
							});
						}


					}).catch(function (error) {
					console.log("er store" + error);
				});
			},
			cargarLinks() {
				axios.post(this.URL_BASE() + "link").then(
					respuesta => {
						if (respuesta.data.msg == 'exito') {
							this.links = [...respuesta.data.data];
						}

					}).catch(function (error) {
					console.log("er store" + error);
				});
			},
			formatDate(d) {
				var monthsName = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
				d = new Date(d);
				d = monthsName[d.getMonth()] + ' ' + d.getDate();
				return d;
			},
			playAnimation() {
				this.scaleClass = false;
				this.$refs.number2.play();
			},
			completed() {
				this.scaleClass = true;
			},
			theFormat(number) {
				return number.toFixed(2);
			},
			validarEscolaridad(mes) {
				return ['Enero', 'Febrero'].includes(mes);
			},
			validarFiestasPatrias(mes) {
				return ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio'].includes(mes);
			},
			validarFiestasNavidad(mes) {
				return ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Setiembre', 'Octubre',
					'Noviembre'
				].includes(mes);
			},
			filtrar(tipo){
			  let nuevoTipo=this.$store.state.dataTipoVendedor.filter(elemento=>elemento.Id==tipo);

			  return nuevoTipo[0].tipo;
			},
			imprimirBoleta(pagoChip, pagoEquipo, pagoAdelanto, pagoTotal, mes) {
				var mywindow = window.open('', 'Boleta', "scrollbars=yes, titlebar=yes");
				// var mywindow = window.open('', '_self').close();
				mywindow.document.write('<html><head>');
				mywindow.document.write(
					'<style>.tabla{width:100%;border-collapse:collapse;margin:16px 0 16px 0;}.tabla th{border:1px solid #ddd;padding:4px;background-color:#d4eefd;text-align:left;font-size:15px;}.tabla td{border:1px solid #ddd;text-align:left;padding:6px;}</style>'
					);
				mywindow.document.write('</head><body >');
				mywindow.document.write('<table class="tabla">');
				mywindow.document.write('<tr>');
				mywindow.document.write('<td style="width:50%">');
				mywindow.document.write('<img src="https://telemartin.com/app/assets/logo.png">');
				mywindow.document.write('</td>');
				mywindow.document.write('<td style="width:50%;text-align:right">');
				mywindow.document.write('<h1>TeleMartin</h1>');
				mywindow.document.write('<h3><i>Creciendo sin límites</i></h3>');
				mywindow.document.write('</td>');
				mywindow.document.write('</tr>');
				mywindow.document.write('<tr>');
				mywindow.document.write('<th colspan="2">');
				mywindow.document.write('PAGO DEL MES: ' + mes);
				mywindow.document.write('</th>');
				mywindow.document.write('</tr>');
				mywindow.document.write('<tr>');
				mywindow.document.write('<th colspan="2">');
				mywindow.document.write('PERSONAL: <b>' + this.$store.state.usuario.nombres + ' ' + this.$store.state
					.usuario.appa + ' ' + this.$store.state.usuario.apma + '</b>');
				mywindow.document.write('</th>');
				mywindow.document.write('</tr>');
				mywindow.document.write('<tr>');
				mywindow.document.write('<td colspan="2">');
				mywindow.document.write('<B>A PAGAR:</B>');
				mywindow.document.write('</td>');
				mywindow.document.write('</tr>');
				mywindow.document.write('<tr>');
				mywindow.document.write('<td>');
				mywindow.document.write('--------PAGO ACTIVACIONES DE CHIPS');
				mywindow.document.write('</td>');
				mywindow.document.write('<td>');
				mywindow.document.write(pagoChip);
				mywindow.document.write('</td>');
				mywindow.document.write('</tr>');
				mywindow.document.write('<tr>');
				mywindow.document.write('<td>');
				mywindow.document.write('--------PAGO DE VENTA DE EQUIPOS');
				mywindow.document.write('</td>');
				mywindow.document.write('<td>');
				mywindow.document.write(pagoEquipo);
				mywindow.document.write('</td>');
				mywindow.document.write('</tr>');
				mywindow.document.write('<tr>');
				mywindow.document.write('<td>');
				mywindow.document.write('</td>');
				mywindow.document.write('<td>');
				mywindow.document.write('<B>' + (Number(pagoEquipo) + Number(pagoChip)).toFixed(2) + "</B>");
				mywindow.document.write('</td>');
				mywindow.document.write('</tr>');
				mywindow.document.write('<tr>');
				mywindow.document.write('<td colspan="2">');
				mywindow.document.write('<B>ADELANTOS:</B>');
				mywindow.document.write('</td>');
				mywindow.document.write('</tr>');
				mywindow.document.write('<tr>');
				mywindow.document.write('<td>');
				mywindow.document.write('--------MONTO DE ADELANTO');
				mywindow.document.write('</td>');
				mywindow.document.write('<td>');
				mywindow.document.write(pagoAdelanto);
				mywindow.document.write('</td>');
				mywindow.document.write('</tr>');
				mywindow.document.write('<tr>');
				mywindow.document.write('<th>');
				mywindow.document.write('TOTAL A PAGAR EN EL MES DE: ' + mes);
				mywindow.document.write('</th>');
				mywindow.document.write('<th>');
				mywindow.document.write("<h4>S/." + pagoTotal + "</h4>");
				mywindow.document.write('</th>');
				mywindow.document.write('</tr>');

				if (false) {
					// if(this.$store.state.usuario.tipo_vendedor==2){
					mywindow.document.write('<tr>');
					mywindow.document.write('<th colspan="2" style="text-align:center">');
					mywindow.document.write('--------------------------------');
					mywindow.document.write('</th>');
					mywindow.document.write('</tr>');
					mywindow.document.write('<tr>');
					mywindow.document.write('<th colspan="2">');
					mywindow.document.write('USTED VIENE ACUMULANDO:');
					mywindow.document.write('</th>');
					mywindow.document.write('</tr>');

					mywindow.document.write('<tr>');
					mywindow.document.write('<td>');
					mywindow.document.write('--------AGUINALDO POR ESCOLARIDAD:');
					mywindow.document.write('</td>');
					mywindow.document.write('<td>');
					mywindow.document.write('S/.' + this.escolaridad_total);
					mywindow.document.write('</td>');
					mywindow.document.write('</tr>');

					mywindow.document.write('<tr>');
					mywindow.document.write('<td>');
					mywindow.document.write('--------AGUINALDO POR FIESTAS PATRIAS:');
					mywindow.document.write('</td>');
					mywindow.document.write('<td>');
					mywindow.document.write('S/.' + this.fiestas_patrias_total);
					mywindow.document.write('</td>');
					mywindow.document.write('</tr>');

					mywindow.document.write('<tr>');
					mywindow.document.write('<td>');
					mywindow.document.write('--------AGUINALDO POR NAVIDAD:');
					mywindow.document.write('</td>');
					mywindow.document.write('<td>');
					mywindow.document.write('S/.' + this.navidad_total);
					mywindow.document.write('</td>');
					mywindow.document.write('</tr>');
				}

				// mywindow.document.write(document.getElementById('muestra').innerHTML);
				mywindow.document.write('</table>');
				mywindow.document.write('</body></html>');
				mywindow.document.close(); // necesario para IE >= 10
				mywindow.focus(); // necesario para IE >= 10
				mywindow.print();
				// mywindow.close();
				return true;
			}

		},
		computed: {
			escolaridad_total() {
				let total = 0;
				this.montos_anteriores.forEach(element => {
					if (this.validarEscolaridad(element.mes)) {
						total = total + (element.monto_chip * 0.15);
					}
				});
				return total.toFixed(2);
			},
			fiestas_patrias_total() {
				let total = 0;
				this.montos_anteriores.forEach(element => {
					if (this.validarFiestasPatrias(element.mes)) {
						total = total + (element.monto_chip * 0.10);
					}
				});
				return total.toFixed(2);
			},
			navidad_total() {
				let total = 0;
				this.montos_anteriores.forEach(element => {
					if (this.validarFiestasNavidad(element.mes)) {
						// total=total+(Number(element.total)*0.10).toFixed(2);
						total = total + (element.monto_chip * 0.10);
					}
				});
				return total.toFixed(2);
			}
		}
	}
</script>